// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2V6Jx","name":"ConsentHeader_name__i0aSW","birthday":"ConsentHeader_birthday__276jX","skeleton":"ConsentHeader_skeleton__76OV4"};